// extracted by mini-css-extract-plugin
module.exports = {"section_bg":"CardList_section_bg__3Nl4m","pagination":"CardList_pagination__lfnU3"};